import { useEffect, useState } from "react"
import { InductionConfiguration, InductionQuizConfiguration } from "../TypesOrInterfaces/induction"
import { getQuizMovedToBeneficiaryForm } from "../util/quizForm"

export const useAstrazeneca = (configuration: InductionConfiguration, benefitId?: number) => {

    const [termBeneficiary, setTermBeneficiary] = useState<InductionQuizConfiguration>({} as InductionQuizConfiguration)
    useEffect(() => {
        if (configuration.quiz) {
            setTermBeneficiary(getQuizMovedToBeneficiaryForm(configuration, benefitId) || ({} as InductionQuizConfiguration))
        }
    }, [benefitId, configuration])

    return {
        termBeneficiary
    }
}


